module.exports = __webpack_public_path__ + "static/img/19071a527ed4feb69bbf05a8044a2b92.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Mode0-show-1.png
// module id = 6bRN
// module chunks = 1